import { createContext } from 'react'

import type { ShowResolvedState } from './types'

export const ShowResolvedCtx = createContext<ShowResolvedState | null>(null)
